// =============================================================================
// src/theme/neutrals.js
// Brand-agnostic UI grays — not part of the Iris Floral palette, so they live
// outside colors.js (see that file's own "single source of truth" header).
// A neutral gray like this doesn't derive from any brand token: solving for
// what opacity of TWILIGHT_NAVY would produce it gives inconsistent values
// per channel, confirming it isn't palette drift.
// =============================================================================

// Unchecked/empty state for circular checkmark badges (ProtocolCard.js,
// ProtocolMockCards.js's matching landing mock).
export const UNCHECKED_GRAY = '#F0F0F0';
